<div class="content-container">
  <mat-toolbar class="sticky-toolbar">
    <h2>
      <span class="opacity-75">
        <a routerLink="/home" id="licenses-breadcrumb-home">Home</a> /
      </span>
      {{ pageTitle }}
    </h2>
    <span class="spacer"></span>
    <button mat-mini-fab [matMenuTriggerFor]="licensesActions" id="licenses-actions-button" matTooltip="More options">
      <mat-icon>menu</mat-icon>
    </button>
    <mat-menu #licensesActions="matMenu">
      <button mat-menu-item id="licenses-refresh-button" (click)="refresh()">
        <mat-icon>refresh</mat-icon>
        Refresh
      </button>
      <mat-divider *ngIf="!activityTab"></mat-divider>
      <button mat-menu-item id="licenses-toggle-activation-codes" (click)="toggleActivationCodes()" *ngIf="!surrenderTab && !activityTab">
        <mat-icon>{{ showActivationCodes ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
        Show Activation Keys
      </button>
      <button mat-menu-item id="licenses-toggle-comments" (click)="toggleComments()" *ngIf="!activityTab">
        <mat-icon>{{ showComments ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
        Show Comments
      </button>
    </mat-menu>
  </mat-toolbar>

  <div class="sub-content-container">
    <div class="container-fluid pd-20" *ngIf="loading">
      <mat-card class="portal-message-card">
        <mat-card-content class="page-loading-card">
          <mat-spinner diameter="56"></mat-spinner>
        </mat-card-content>
      </mat-card>
    </div>

    <div class="container-fluid pd-20" *ngIf="!loading && contract; else noContract">
      <app-license-overview *ngIf="activetab === 1" #viewTab [contract]="contract" [showComments]="showComments"></app-license-overview>

      <ng-container *ngIf="activetab === 2">
        <app-license-activation *ngIf="!disableActTab" #actTab [contract]="contract"></app-license-activation>
        <mat-card *ngIf="disableActTab" id="licenses-activate-disabled" class="portal-message-card">
          <mat-card-content>You cannot activate licenses for this product.</mat-card-content>
        </mat-card>
      </ng-container>

      <ng-container *ngIf="activetab === 3">
        <app-license-surrender *ngIf="!disableSurrenderTab" #surrenderTab [contract]="contract"
          [showComments]="showComments"></app-license-surrender>
        <mat-card *ngIf="disableSurrenderTab" id="licenses-surrender-disabled" class="portal-message-card">
          <mat-card-content>You cannot surrender licenses for this product.</mat-card-content>
        </mat-card>
      </ng-container>

      <app-token-request *ngIf="activetab === 4 && !disableTokenTab" #tokenTab [contract]="contract"></app-token-request>
      <mat-card *ngIf="activetab === 4 && disableTokenTab" id="licenses-token-disabled" class="portal-message-card">
        <mat-card-content>You can only request tokens for CloneManager or FSBlocker contracts.</mat-card-content>
      </mat-card>

      <app-activity-tab *ngIf="activetab === 5" #activityTab [contract]="contract"></app-activity-tab>
      <app-offline-surrender *ngIf="activetab === 6" #offlineTab [contract]="contract"></app-offline-surrender>
    </div>
  </div>
</div>

<ng-template #noContract>
  <div class="sub-content-container" *ngIf="!loading">
    <div class="container-fluid pd-20">
      <mat-card id="licenses-empty-state" class="portal-message-card">
        <mat-card-content>No contracts available.</mat-card-content>
      </mat-card>
    </div>
  </div>
</ng-template>
